/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate, useParams } from "react-router-dom";
import { RoutedModal } from "../../../../components/common";
import { pathConstants } from "../../../../routes/pathContants";
import primaryComponents from "../../../../components/primaryComponents";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { useSalesTransactions } from "../../../appPages/Inventory/SalesTransactions/useSalesTransactions";
import { useEffect } from "react";
import secondaryComponents from "../../../../components/secondaryComponents";
import { orderStatus } from "../../../../localdata";
import { useSelector } from "react-redux";

export const SMSalesHome = () => {
  const navigate = useNavigate();
  const { store_id } = useParams();
  const {
    search,
    isFetchingSalesTransactions,
    metaDetails,
    salesTransactions,
    setSearch,
    gotoPage,
    filterByStoreType,
    filterBySearch,
    filterByStatus,
  } = useSalesTransactions({
    isUserListEnabled: false,
  });
  const { has_chowdeck_connection } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );

  useEffect(() => {
    if (!search.get("store_id") || !search.get("order_source")) {
      search.set("order_source", search.get("order_source") || "INTERNAL");
      search.set("store_id", search.get("store_id") || store_id);
      setSearch(search, { replace: true });
    }
  }, []);

  return (
    <RoutedModal
      isActive={true}
      headerTitle="Sales"
      headerDescription="View, filter your sales transactions"
      closeModal={() =>
        navigate(pathConstants.SELL_MODE({ store_id: store_id }))
      }
    >
      <div className={globalStyles.rowNavigations}>
        <a
          className={`${globalStyles.rowNavigations__item} ${
            search.get("order_source") === "INTERNAL" ? globalStyles.active : ""
          }`}
          onClick={() => filterByStoreType("INTERNAL", true)}
        >
          Instore Sales
        </a>

        <a
          className={`${globalStyles.rowNavigations__item} ${
            search.get("order_source") === "STOREFRONT"
              ? globalStyles.active
              : ""
          }`}
          onClick={() => filterByStoreType("STOREFRONT", true)}
        >
          Online Sales
        </a>

        {has_chowdeck_connection ? (
          <a
            className={`${globalStyles.rowNavigations__item} ${
              search.get("order_source") === "CHOWDECK"
                ? globalStyles.active
                : ""
            }`}
            onClick={() => filterByStoreType("CHOWDECK", true)}
          >
            Chowdeck Orders
          </a>
        ) : null}
      </div>

      <section className={`${globalStyles.cardWithBorder} overflow-hidden p-0`}>
        <div className={globalStyles.tableHeader}>
          <primaryComponents.SearchField
            classNames={globalStyles.searchField}
            placeholder="Search by order ID"
            trigger={(value) => filterBySearch(value)}
            value={search.get("query") !== null ? search.get("query") : ""}
            triggerOnInput={true}
            showsearchBtn={true}
          />

          <div className="ml-auto" style={{ width: "160px" }}>
            <primaryComponents.SelectField
              value={
                orderStatus?.find(
                  (status) => status?.value === search.get("status"),
                )?.label || "Select status"
              }
              options={orderStatus}
              onChange={(value) => {
                filterByStatus(value);
              }}
              nameKey="label"
              idKey="value"
              floatError={false}
            />
          </div>
        </div>

        <secondaryComponents.LoaderHelper
          isLoading={isFetchingSalesTransactions}
          classNames="my-5"
        >
          <secondaryComponents.SalesTransactionsTable
            metaDetails={metaDetails}
            salesTransactions={salesTransactions}
            gotoPage={gotoPage}
            isViaSellMode={true}
          />
        </secondaryComponents.LoaderHelper>
      </section>
    </RoutedModal>
  );
};
